<template>
  <div class="flex flex-wrap">

    <!-- <div class="w-full header flex justify-between p-3 px-5 text-white">
      <div class="flex flex-shrink-0">
          <img
                src="https://upload.wikimedia.org/wikipedia/commons/8/87/MPL_Logo.png"
                alt="Workflow logo"
                class="h-12 w-12"
              />
          <div class="px-3 pt-1">
            <p class=" font-medium">My Bandharu</p>
            <p class="text-xs font-medium uppercase">Maldives Ports Limited</p>
          </div>
      </div>
      <div class="flex flex-row">
        <div class="px-2 pt-3">
          <a href="https://my.port.mv/register">
            <button class="outline-none mr-2"><span class="text-medium hover:font-semibold transition-all duration-200 ease-in-out">REGISTER</span></button>
          </a>
        </div>
        <div class="px-2 pt-3">
          <a href="https://my.port.mv/login">
            <button class="outline-none"><span class="text-medium hover:font-semibold transition-all duration-200 ease-in-out">LOGIN</span>
            </button>
          </a>
        </div>
      </div>
    </div> -->

    <!--
        <div v-if="currentView === 'faq'" class="container mx-auto px-2 mt-2">
          <div class="flex flex-wrap my-2 ">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
            </svg>
            <button v-on:click="setView('main')" class="ml-2">Go Back</button>
          </div>
        </div> -->
    <!-- <FAQ v-if="currentView === 'faq'"/> -->

    <div v-if="currentView === 'main'" class="flex flex-wrap">
      <div class="w-full sm:w-full md:w-full lg:w-3/6 xl:w-3/6">
        <ContainerSearch/>
        <ShipsAtPort/>
        <DailyExpress/>
        <OverallStatistics class="hidden md:block"/>
        <EstimatedArrival/>
        <OverallStatistics class="block md:hidden"/>
        <KnowledgeCenter class="hidden md:block"/>

      </div>


      <div class="w-full sm:w-full md:w-full lg:w-3/6 xl:w-3/6">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <a href="https://my.port.mv/faq">
              <div class="card card-clickable" style="padding: 2em">
                <img src="./faq.svg" alt="FAQ">
                <!-- <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_fi0ty9ak.json"  background="transparent"  speed="1"   loop center autoplay></lottie-player> -->
                <!-- <h5 class="faq-header">Frequently Asked Questions</h5> -->
              </div>
            </a>
            <ShippingAgents/>
            <Tarrifs/>

          </div>
          <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2">

            <div class="card">
              <div class="card-header">
                <div class="flex justify-between">
                  <div>
                    <h2 class="card-heading">Important Contacts</h2>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <div class="flex flex-wrap gap-2">
                  <div v-for="item in contacts" v-bind:key="item.pos" class="w-full">
                    <div class="bg-slate-100 rounded-lg">
                      <div :style="'background-color:'+item.color"
                           :class="item.color + ' text-white rounded-t-lg py-2 px-3 font-medium text-xs'">
                        {{ item.name }}
                      </div>
                      <div class="px-3 py-3 text-xs text-slate-800">
                        <div v-for="phone in item.phone" v-bind:key="phone.pos">
                          <a :href=" 'tel:960'+ phone">
                            <p class="mb-1">
                              <i class="fal fa-phone-office text-sm mr-2"></i>+960
                              {{ phone }}
                            </p>
                          </a>
                        </div>

                        <p class="mb-1">
                          <i class="fal fa-envelope text-sm mr-2"></i
                          >{{ item.email }}
                        </p>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
            <KnowledgeCenter class="block md:hidden"/>

          </div>
          <!-- <div class="w-full">
            <KnowledgeCenter />
          </div> -->
        </div>
      </div>
    </div>


    <div class="w-full text-center py-5 text-xs text-slate-400">
      <p> {{ new Date().getFullYear() }} Maldives Ports Limited. All Rights Reserved.</p>
    </div>
  </div>
</template>
<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import UserService from "@/services/user.service";
import ContainerSearch from "@/components/ContainerSearch.vue";
import ShipsAtPort from "@/components/ShipsAtPort.vue";
import EstimatedArrival from "@/components/EstimatedArrival.vue";
import KnowledgeCenter from "@/components/KnowledgeCenter.vue";
import ShippingAgents from "@/components/ShippingAgents.vue";
import OverallStatistics from "@/components/OverallStatistics.vue";
import DailyExpress from "@/components/DailyExpress.vue";
import Tarrifs from "@/components/Tarrifs.vue";
import WeatherForecast from "@/components/WeatherForecast.vue";
import MainPage from "@/components/MainPage.vue";
import FAQ from "@/components/FAQ.vue";
import ScreenAlert from "@/components/ScreenAlert.vue";

@Component({
  components: {
    ContainerSearch,
    ScreenAlert,
    ShipsAtPort,
    EstimatedArrival,
    KnowledgeCenter,
    ShippingAgents,
    OverallStatistics,
    DailyExpress,
    Tarrifs,
    WeatherForecast,
    MainPage,
    FAQ
  },
})
export default class Login extends Vue {
  private userservice = new UserService();
  private currentView = 'main';


  private contacts = [
    {
      name: 'Pilotage & Marine Service',
      color: '#f56565',
      phone: ['3008922'],
      email: 'pmd@port.mv'
    },
    {
      name: 'Cargo Clearance - HelpDesk',
      color: '#9f7aea',
      phone: ['3328995'],
      email: 'clearance@port.mv'
    },
    {
      name: 'Cargo Operations',
      color: '#48bb78',
      phone: ['3317482'],
      email: 'cargo@port.mv'
    },
    {
      name: 'Cargo Claims',
      color: '#786fa6',
      phone: ['3322665'],
      email: 'cargoclaims@port.mv'
    },
    {
      name: 'Data Processing Unit',
      color: '#4299e1',
      phone: ['3322355'],
      email: 'dpu@port.mv'
    },
    {
      name: 'Finance - Payments',
      color: '#f56565',
      phone: ['3314881'],
      email: 'payments@port.mv'
    },
    {
      name: 'Finance - Revenue',
      color: '#f56565',
      phone: ['3318781'],
      email: 'receivables@port.mv'
    },

  ]


}
</script>
